// extracted by mini-css-extract-plugin
module.exports = {"overlayConfirmation":"ConfirmationModal_overlayConfirmation__DOKVK"};